import React, { useEffect } from "react";
import Header from "../header/index";
import Footer from "../../components/footer/index";
import PartnerBrand from "../partnerBranding";
import { useDispatch, useSelector } from "react-redux";
import { getPartnerDetails, getServiceInfo } from "../../selector";
import { requestPartnerDetails } from "../../action";
import { getRescueTrackerChatFlag } from "../../features";
import { determineLocale } from "../../contexts/LocaleContext";
import { isEnglishLocale } from "../../utils";

const DefaultLayout = ({ children, isRescueTrackerStandalone, hideMenu }) => {
  const dispatch = useDispatch();
  const partnerDetails = useSelector(getPartnerDetails);
  const isRescueTrackerChatEnabled = useSelector(getRescueTrackerChatFlag);
  const locale = determineLocale();

  useEffect(() => {
    if (isRescueTrackerStandalone) {
      dispatch(requestPartnerDetails(window.location.pathname.split("/")[3]));
    }
  }, []);

  const serviceInfo = useSelector(getServiceInfo);

  const {
    hasAllstateBrandHeader,
    hasAllstateBrandFooter,
    phone,
    displayCode,
    isFooterBrandingEnabled,
    isHeaderBrandingEnabled,
    isHeaderDisabled,
    isFooterDisabled,
    displayFeedbackModal,
  } = partnerDetails;

  const currentPage = window.location.pathname.split("/")[3];
  const hidePartnerBrandAndFooter = [
    "location",
    "disablementlocation",
    "payment",
    "triage-steps",
    "confirm-vehicle",
    "add-vehicle",
    "incident-report",
    "CallUs",
  ].includes(currentPage);
  const isAllstateBranded = hasAllstateBrandFooter && hasAllstateBrandHeader;
  const isNoBranding = !(isHeaderBrandingEnabled || isFooterBrandingEnabled);
  const shouldDisplayPartnerBrand = !(
    isAllstateBranded ||
    hidePartnerBrandAndFooter ||
    isNoBranding ||
    isHeaderDisabled
  );

  const hideMenuForRescueTracker = isRescueTrackerStandalone && isRescueTrackerChatEnabled && isEnglishLocale(locale);

  return (
    <>
      <Header
        hasAllstateBrandHeader={hasAllstateBrandHeader}
        isHeaderBrandingEnabled={isHeaderBrandingEnabled}
        isHeaderDisabled={isHeaderDisabled}
        phone={phone}
        displayFeedbackModal={displayFeedbackModal}
        displayCode={displayCode}
        serviceInfo={serviceInfo}
        hideMenuButton={hideMenuForRescueTracker || hideMenu}
      />
      {shouldDisplayPartnerBrand ? (
        <PartnerBrand isRescueTrackerStandalone={isRescueTrackerStandalone} />
      ) : null}
      {children}
      {hidePartnerBrandAndFooter || isFooterDisabled ? null : (
        <Footer
          isRescueTrackerStandalone={isRescueTrackerStandalone}
          hasAllstateBrandFooter={hasAllstateBrandFooter}
          isFooterBrandingEnabled={isFooterBrandingEnabled}
        />
      )}
    </>
  );
};

export default DefaultLayout;
